import React from "react";
import PropTypes from "prop-types";
import { Header } from "semantic-ui-react";

const HomePageWidgetLayout = ({ title, children }) => {
  return (
    <>
      <Header as="h3">{title}</Header>
      {children}
    </>
  );
};

HomePageWidgetLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default HomePageWidgetLayout;
